import { render, staticRenderFns } from "./PurExL.vue?vue&type=template&id=687d3dc2"
import script from "./PurExL.vue?vue&type=script&lang=js"
export * from "./PurExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports